import { promotionTableLabels } from '../pt-promotion-coupon/promotion-option'
export let pageTab = [
  {
    label: '待客服审核',
    value: 'UNAUDITED'
  },
  {
    label: '待财务审核',
    value: 'WAITING_FINANCIAL_AUDIT'
  },
  {
    label: '已审核',
    value: 'AUDITED'
  }
]
export let promotionTableLabel = promotionTableLabels
export let waitApproveTableLabels = [
  ...promotionTableLabels,
  {
    label: '申请人',
    value: 'editorInfo.operatorName'
  }
]
export let approvedTableLabels = [
  ...waitApproveTableLabels,
  {
    label: '审批人',
    value: 'auditInfo.operatorName'
  }
]
